<template>
  <path
    id="Oval-2"
    d="M12,19 C11.4477153,19 11,18.5522847 11,18 C11,17.4477153 11.4477153,17 12,17 C12.5522847,17 13,17.4477153 13,18 C13,18.5522847 12.5522847,19 12,19 Z M12,6 C14.2056,6 16,7.70895238 16,9.80952381 C16,11.581381 14.7233,13.0745714 13,13.4985238 L13,15.047619 C13,15.573619 12.5523,16 12,16 C11.4477,16 11,15.573619 11,15.047619 L11,12.6666667 C11,12.1406667 11.4477,11.7142857 12,11.7142857 C13.1028,11.7142857 14,10.8598095 14,9.80952381 C14,8.7592381 13.1028,7.9047619 12,7.9047619 C10.8972,7.9047619 10,8.7592381 10,9.80952381 C10,10.3355238 9.5523,10.7619048 9,10.7619048 C8.4477,10.7619048 8,10.3355238 8,9.80952381 C8,7.70895238 9.7944,6 12,6 Z M12,0 C18.6329531,0 24,5.3679375 24,12 C24,18.6329531 18.6320625,24 12,24 C5.36704687,24 0,18.6320625 0,12 C0,5.36704687 5.3679375,0 12,0 Z M12,22.125 C17.5965469,22.125 22.125,17.5957969 22.125,12 C22.125,6.40345313 17.5957969,1.875 12,1.875 C6.40345313,1.875 1.875,6.40420313 1.875,12 C1.875,17.5965469 6.40420313,22.125 12,22.125 Z"
    :fill="iconColor"
  />
</template>

<script>
export default {
    name: 'QuestionIcon',
    props: {
        iconColor: {
            type: String,
            default: 'currentColor'
        }
    }
};
</script>

<style scoped></style>
